import React, { useMemo } from "react";
import { BASE_PAYMENTUS_PRELOAD_PATHS } from "../../..";
import { usePaymentContext } from "../../../contexts/payment-context";

export const PaymentusPreloadElements = (): JSX.Element => {
  const { paymentusIframeBaseUrl } = usePaymentContext();

  const envCacheItems = useMemo(() => {
    if (paymentusIframeBaseUrl?.includes("staging")) {
      return {
        path: "application/staging-config.json",
        type: "application/json",
      };
    } else if (paymentusIframeBaseUrl?.includes("test")) {
      return {
        path: "application/test-config.json",
        type: "application/json",
      };
    } else if (paymentusIframeBaseUrl?.includes("dev")) {
      return {
        path: "application/dev-config.json",
        type: "application/json",
      };
    } else {
      return {
        path: "application/prod-config.json",
        type: "application/json",
      };
    }
  }, [paymentusIframeBaseUrl]);

  return (
    <>
      {BASE_PAYMENTUS_PRELOAD_PATHS.concat(envCacheItems).map((preload) => {
        return (
          <link
            key={preload.path}
            rel="prefetch"
            href={`${paymentusIframeBaseUrl}/${preload.path}`}
            as={preload.type}
          />
        );
      })}
    </>
  );
};
